import * as API  from '@/API'

// 公共参数
const page = 'package message -';

// 编辑参数
export const EDIT_PARAM = `${page} edit param`;
export const editParam = (data) => {
	return {
	    type: EDIT_PARAM,
	    payload: data
	}
}





// WEBPACK FOOTER //
// ./src/entry_app/question_manage/check_beyond_level/action.js